import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSteps } from '../api/courses.api';
import useAxios from '../hooks/useAxios';
import { Select } from 'antd';
import ErrorResponse from './ErrorResponse';
import Loader from './Loader';
import { IGetSteps, IStep } from '../models/courses.model';

interface IProps {
  value: string|undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
  isAllOption?: boolean;
  placeHolder?: string|undefined;
  steps?: IStep[];
  className?: string;
}

const SelectLevel: FC<IProps> = ({
  value,
  onChange,
  disabled = false,
  isAllOption = false,
  placeHolder,
  steps,
  className
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSteps>();
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    if (!steps) {
      execute(getSteps());
    }
  }, []);

  useEffect(() => {
    if (steps || res) {
      const _options: any = [];
      (steps || res?.data)?.forEach((item: any) => {
        const option = (
          <Select.OptGroup key={item.courseCode} label={item.courseName}>
            {item.step.map((subitem: any) => (
              <Select.Option
                key={subitem.courseCode}
                value={String(subitem.courseCode)}
              >
                {subitem.courseName}
              </Select.Option>
            ))}
          </Select.OptGroup>
        );
        _options.push(option);
      });

      setOptions(_options);
    }
  }, [steps, res]);

  return (
    <>
      {isLoading ? <Loader isInBox={true} /> : null}
      <ErrorResponse error={error} />
      <Select
        className={className || 'w-150p'}
        placeholder={t(`${placeHolder ? placeHolder : 'class.levelUp.placeholder1'}`)}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {isAllOption && (
          <Select.Option key="all" value="">
            {t('common.text.all')}
          </Select.Option>          
        )}
        {options}
      </Select>
    </>
  );
};

export default SelectLevel;
